import React, { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Alert from '../shared/Alert'

const InviteAccept = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const token = searchParams.get('token')

  const handleSubmit = async e => {
    e.preventDefault()
    setError(null)
    setLoading(true)

    if (password !== confirmPassword) {
      setError("Passwords don't match")
      setLoading(false)
      return
    }

    try {
      const response = await fetch('/collectors/api/accept_invite', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        },
        body: JSON.stringify({
          token,
          password,
        }),
      })

      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.message || 'Failed to set password')
      }

      // Redirect to login page
      navigate('/collectors')
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='container mt-5 mb-14'>
      <div className='row justify-content-center'>
        <div className='col-md-6'>
          <div className='card'>
            <div className='card-body'>
              <h2 className='card-title mb-4'>Set Your Password</h2>

              {error && <Alert type='danger'>{error}</Alert>}

              <form onSubmit={handleSubmit}>
                <div className='mb-3'>
                  <label className='form-label'>New Password</label>
                  <input
                    type='password'
                    className='form-control'
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                  />
                </div>

                <div className='mb-3'>
                  <label className='form-label'>Confirm Password</label>
                  <input
                    type='password'
                    className='form-control'
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>

                <p className='text-muted'>
                  <a href='/collectors'>Already have a password?</a>
                </p>

                <button type='submit' className='btn btn-primary' disabled={loading}>
                  {loading ? 'Setting Password...' : 'Set Password'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InviteAccept
